import cn from 'classnames'
import Image from 'next/image'
import {FC} from 'react'

import {CardWrapper} from '@/components/common/cards/CardWrapper'
import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {Link} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type IpCaseCardProps = {
  title: string
  linkHref: string
  coverImage: string
  description: string
  fullWidth?: boolean
}

export const IpCaseCard: FC<IpCaseCardProps> = ({
  title,
  linkHref,
  coverImage,
  description,
  fullWidth = false,
}) => (
  <>
    <CardWrapper isHoverable={false} fullWidth={fullWidth}>
      <Link href={linkHref} prefetch={false}>
        <div className={cn('card', fullWidth && 'full-width')}>
          <div className="thumbnail-mask">
            <div className="thumbnail">
              <Image
                src={coverImage}
                alt={title}
                fill
                sizes={`${MOBILE_SCREENSIZE} 100vw, ${TABLET_SCREENSIZE} 50vw, 353px`}
                style={{objectFit: 'cover'}}
              />
            </div>
          </div>
          <div className="content">
            <Text variant={TextVariant.h5} element="h3" fontWeight={TextFontWeight.bold}>
              {title}
            </Text>
            <div className="description">
              <Text color={theme.palette.text.light}>{description}</Text>
            </div>
          </div>
        </div>
      </Link>
    </CardWrapper>

    <style jsx>{`
      .card {
        height: 100%;
      }
      .thumbnail-mask {
        overflow: hidden;
        width: 100%;
        height: 180px;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
      }
      .thumbnail {
        position: relative;
        width: 100%;
        height: 100%;
      }
      .content {
        padding: ${theme.spacing[4]};
      }
      .description {
        margin-top: ${theme.spacing[2]};
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
      }
      .full-width {
        display: flex;
      }
      .full-width .thumbnail-mask {
        width: initial;
        height: initial;
        min-width: 280px;
        height: auto;
        min-height: 188px;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        border-top-right-radius: 0;
      }
      @media ${MOBILE_SCREENSIZE} {
        .content {
          padding: ${theme.spacing[3]};
        }
        .thumbnail-mask {
          height: 130px;
        }
        .full-width {
          display: block;
        }
        .full-width .thumbnail-mask {
          height: 130px;
          min-width: inherit;
          min-height: inherit;
          border-bottom-left-radius: 0;
          border-top-right-radius: 12px;
        }
      }
    `}</style>
  </>
)
